import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * SEO component - sets meta tags, OG, Twitter card, and JSON-LD.
 */
const SEO = ({
  title = "Corona Gas, HVAC, Heating, Air Conditioning & Gas Fitting Experts in BC",
  description = "Corona Gas: 20+ years of trusted HVAC, heating, air conditioning, and gas fitting service across BC's Lower Mainland. Free quotes and CleanBC rebate assistance.",
  url = "https://coronagas.ca/",
  image = "https://images.unsplash.com/photo-1585129777188-94600bc7b4b3?w=1200&auto=format&fit=crop&q=80",
  keywords = "HVAC BC, heat pump rebate BC, CleanBC heat pump, gas fitter Vancouver, furnace repair Surrey, air conditioning install BC, Corona Gas, HVAC contractor Lower Mainland",
  jsonLd,
  type = "website",
}) => {
  const defaultJsonLd = {
    "@context": "https://schema.org",
    "@type": "HVACBusiness",
    name: "Corona Gas",
    image,
    url,
    telephone: "+1-604-576-6457",
    email: "Office@coronagas.ca",
    description,
    address: {
      "@type": "PostalAddress",
      addressLocality: "Surrey",
      addressRegion: "BC",
      postalCode: "V3S 6K1",
      streetAddress: "19289 Langley Bypass",
      addressCountry: "CA",
    },
    areaServed: ["Surrey", "Vancouver", "Burnaby", "Abbotsford", "Lower Mainland BC"],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "3.9",
      reviewCount: "23",
    },
    openingHours: "Mo-Fr 07:00-15:30",
    priceRange: "$$",
  };

  const finalJsonLd = jsonLd || defaultJsonLd;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Corona Gas" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Robots */}
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="theme-color" content="#E50914" />

      {/* JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(finalJsonLd)}
      </script>
    </Helmet>
  );
};

export default SEO;
